import { render, staticRenderFns } from "./Info_contorl.vue?vue&type=template&id=1a3f57b6"
import script from "./Info_contorl.vue?vue&type=script&lang=js"
export * from "./Info_contorl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports